import React from "react";
import { Box, Paper, Typography, CircularProgress } from "@mui/material";
import UploadBarChart from "./UploadbarChart";
import UploadPieChart from "./UploadpieChart";
import UploadAreaChart from "./UploadareaChart";
import { GraphDataItem, UploadData } from "./DashboardTypes";

interface DashboardContentProps {
  counts: {
    business_description_count: number;
    process_map_count: number;
    value_creation_count: number;
  };
  graphData: GraphDataItem[];
  uploadData: UploadData;
  selectedSection: string;
  selectedDate: {
    year: string;
    month: string;
  };
  countsState: { isLoading: boolean; error: string | null };
  graphState: { isLoading: boolean; error: string | null };
  uploadsState: { isLoading: boolean; error: string | null };
}

const DashboardContent: React.FC<DashboardContentProps> = ({
  counts,
  graphData,
  uploadData,
  selectedSection,
  selectedDate,
  countsState,
  graphState,
  uploadsState,
}) => (
  <Box sx={{ p: 2 }}>
    {/* Counts Section */}
    <Box
      sx={{
        ml: "0px",
        display: "flex",
        justifyContent: "space-between",
        gap: "20px",
        marginBottom: "20px",
      }}
    >
      {countsState.isLoading ? (
        <Box sx={{ width: "100%", textAlign: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      ) : countsState.error ? (
        <Box
          sx={{
            width: "100%",
            textAlign: "center",
            color: "error.main",
            py: 2,
          }}
        >
          {countsState.error}
        </Box>
      ) : (
        <>
          {/* Business Description Card */}
          <Paper sx={{ p: "20px", width: "33%", position: "relative" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                height: "80px",
                flexFlow: "column",
                justifyContent: "end",
                gap: "10px",
              }}
            >
              <h4
                style={{
                  color: "#000",
                  fontSize: "25px",
                  fontWeight: "700",
                  fontFamily: "Avant bold",
                }}
              >
                {counts.business_description_count}
              </h4>
              <p
                style={{
                  color: "#000",
                  fontSize: "18px",
                  fontWeight: "600",
                  fontFamily: "Avant Semibold !important",
                }}
              >
                Business Description
              </p>
            </Box>
            <Typography sx={{ position: "absolute", top: "5px", right: "5px" }}>
              {/* Arrow Icon SVG */}
            </Typography>
          </Paper>

          {/* Process Map Card */}
          <Paper sx={{ p: "20px", width: "33%", position: "relative" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                height: "80px",
                flexFlow: "column",
                justifyContent: "end",
                gap: "10px",
              }}
            >
              <h4
                style={{
                  color: "#000",
                  fontSize: "25px",
                  fontWeight: "700",
                  fontFamily: "Avant bold !important",
                }}
              >
                {counts.process_map_count}
              </h4>
              <p
                style={{
                  color: "#000",
                  fontSize: "18px",
                  fontWeight: "600",
                  fontFamily: "Avant Semibold !important",
                }}
              >
                Process Map
              </p>
            </Box>
            <Typography sx={{ position: "absolute", top: "5px", right: "5px" }}>
              {/* Arrow Icon SVG */}
            </Typography>
          </Paper>

          {/* Mission KPI Card */}
          <Paper sx={{ p: "20px", width: "33%", position: "relative" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                height: "80px",
                flexFlow: "column",
                justifyContent: "end",
                gap: "10px",
              }}
            >
              <h4
                style={{
                  color: "#000",
                  fontSize: "25px",
                  fontWeight: "700",
                  fontFamily: "Avant bold !important",
                }}
              >
                {counts.value_creation_count}
              </h4>
              <p
                style={{
                  color: "#000",
                  fontSize: "18px",
                  fontWeight: "600",
                  fontFamily: "Avant Semibold !important",
                }}
              >
                Mission KPI
              </p>
            </Box>
            <Typography sx={{ position: "absolute", top: "5px", right: "5px" }}>
              {/* Arrow Icon SVG */}
            </Typography>
          </Paper>
        </>
      )}
    </Box>

    {/* Charts Section */}
    <Box sx={{ display: "flex", gap: "20px", width: "100%" }}>
      <Paper sx={{ ml: "0px", p: "20px", height: "100%", width: "52%" }}>
        {graphState.isLoading ? (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : graphState.error ? (
          <Box sx={{ textAlign: "center", color: "error.main", py: 4 }}>
            {graphState.error}
          </Box>
        ) : (
          <UploadBarChart data={graphData} selectedSection={selectedSection} />
        )}
      </Paper>

      <Box
        sx={{
          display: "flex",
          width: "48%",
          gap: "20px",
          height: "100%",
          flexFlow: "column",
        }}
      >
        <Paper sx={{ height: "100%" }}>
          <UploadPieChart data={graphData} />
        </Paper>
        <Paper>
          {uploadsState.isLoading ? (
            <Box sx={{ textAlign: "center", py: 4 }}>
              <CircularProgress />
            </Box>
          ) : uploadsState.error ? (
            <Box sx={{ textAlign: "center", color: "error.main", py: 4 }}>
              {uploadsState.error}
            </Box>
          ) : (
            <UploadAreaChart data={uploadData} selectedDate={selectedDate} />
          )}
        </Paper>
      </Box>
    </Box>
  </Box>
);

export default DashboardContent;
